import dayjs from "dayjs";

import {
  TableMobileHeader,
  TableMobileRow,
  TableMobileRowProps,
} from "../../../Table";
import {
  ApprovedNotFundedColumnLabels,
  ApprovedNotFundedRow,
} from "../../types";
import { COLUMN_DATE_FORMAT } from "../consts";

export type Props = {
  language: string;
  translatedContent: ApprovedNotFundedColumnLabels;
};

export const MobileCardHeader =
  ({ translatedContent }: Props) =>
  (row: ApprovedNotFundedRow) => {
    const { approvalDate, fullName: name, email, clientId } = row;

    const clientIdConfig = {
      value: clientId,
      label: translatedContent.clientId,
    };

    const subHeaderRows: TableMobileRowProps[] = [
      {
        label: translatedContent?.approvalDate ?? "",
        value: approvalDate
          ? dayjs(approvalDate).format(COLUMN_DATE_FORMAT)
          : "-",
      },
    ];

    return (
      <TableMobileHeader
        name={name}
        email={email}
        clientId={clientIdConfig}
        subHeaderRows={subHeaderRows}
      />
    );
  };

export const MobileCardBody =
  ({ translatedContent }: Props) =>
  (row: ApprovedNotFundedRow) => {
    const { tradingAccountID, tradingAccountType, rebateAccount } = row;

    return (
      <>
        <TableMobileRow
          label={`${translatedContent?.acc} #`}
          value={tradingAccountID}
        />
        <TableMobileRow
          label={translatedContent.accType ?? ""}
          value={tradingAccountType}
        />
        <TableMobileRow
          value={rebateAccount}
          label={translatedContent.rebateAccount}
        />
      </>
    );
  };
